import Main from './Main.vue'
import Editar from './components/Editar'
import Excluir from './components/Excluir'

export default [{
  path: 'editar',
  name: 'editar',
  component: Main,
  children: [
  {path: '/editar', component: Editar, name: 'editar'},
  {path: '/excluir', component: Excluir, name: 'excluir'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/utilitarios/routes.js